module.exports = __webpack_public_path__ + "static/img/050吉路通.4d1ec19.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/050吉路通.jpg
// module id = eSy5
// module chunks = 0